import { AnalyticsPage, SentinelBreakdown, TicketMetricsTable, toTableRows, toTicketMetrics } from '@/modules/sentinel-analytics';
import { SENTINEL_TABLE_KEYS } from '@/modules/sentinel-analytics/metric-keys';

export default function TicketMetricsRoute() {
  return (
    <AnalyticsPage title='Ticket Metrics' tabs>
      {(query, dimension) => (
        <SentinelBreakdown query={query} keys={SENTINEL_TABLE_KEYS.tickets} dimension={dimension} groupBys={{ category: [['category'], ['category', 'subcategory']], channel: [['channel']] }}>
          {([groups, subGroups = []]) => (
            <TicketMetricsTable
              nameLabel={dimension === 'channel' ? 'Channel Name' : 'Category Name'}
              rows={toTableRows(groups, dimension, subGroups, (get) => ({ tickets: toTicketMetrics(get) }))}
            />
          )}
        </SentinelBreakdown>
      )}
    </AnalyticsPage>
  );
}
